const fbq = (...args) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq(...args);
    }
};

// Fire-once-per-session guard: prevents duplicates from React StrictMode
// double-mounts, page refreshes, and client-side re-navigation.
const firedOnce = (key) => {
    try {
        const flag = `mp_${key}`;
        if (sessionStorage.getItem(flag)) return false;
        sessionStorage.setItem(flag, "1");
        return true;
    } catch {
        return true;
    }
};

// Reset guards when cart contents change meaningfully (new checkout session)
export const resetCheckoutGuards = () => {
    try {
        Object.keys(sessionStorage)
            .filter((k) => k.startsWith("mp_ic_"))
            .forEach((k) => sessionStorage.removeItem(k));
    } catch {}
};

export const trackViewContent = ({ id, name, value }) =>
    fbq("track", "ViewContent", {
        content_ids: [String(id)],
        content_name: name,
        content_type: "product",
        value: Number(value) || 0,
        currency: "INR",
    });

export const trackAddToCart = ({ id, name, value }) =>
    fbq("track", "AddToCart", {
        content_ids: [String(id)],
        content_name: name,
        content_type: "product",
        value: Number(value) || 0,
        currency: "INR",
    });

export const trackInitiateCheckout = ({ value, numItems, contentIds }) => {
    // One InitiateCheckout per unique cart composition per session —
    // re-entering checkout with the same cart won't re-fire.
    if (!firedOnce(`ic_${(contentIds || []).join("-")}_${value}`)) return;
    fbq("track", "InitiateCheckout", {
        value: Number(value) || 0,
        currency: "INR",
        num_items: numItems,
        content_ids: (contentIds || []).map(String),
    });
};

export const trackPurchase = ({ value, orderId, contentIds }) => {
    // One Purchase per order, ever (survives refresh/redirect loops).
    if (orderId && !firedOnce(`purchase_${orderId}`)) return;
    fbq("track", "Purchase", {
        value: Number(value) || 0,
        currency: "INR",
        order_id: orderId,
        content_ids: (contentIds || []).map(String),
        content_type: "product",
    });
};
